import { useEffect, useState } from 'react';
import { useGetPublic } from '../lib/api/hooks';
import { VersionInfoDto } from '../lib/dtos/VersionInfoDto';
import { getEnv } from '../lib/helper/get-env';

const Version = () => {
    const [commitHash, setCommitHash] = useState<string | undefined>('');
    const [repoName, setRepoName] = useState<string | undefined>('');

    useEffect(() => {
        const getEnvs = async () => {
            return {
                commitHash: await getEnv('VERSION', false),
                repoName: await getEnv('REPO_NAME', false)
            };
        };

        getEnvs().then(({ commitHash, repoName }) => {
            setCommitHash(commitHash);
            setRepoName(repoName);
        });
    }, []);

    const { data, loading } = useGetPublic<VersionInfoDto>('version');

    return (
        <>
            <span id="fe-version">{commitHash}</span>
            <span id="fe-repo-name">{repoName}</span>
            {data && !loading && (
                <>
                    <span id="be-version">{data?.commitHash}</span>
                    <span id="be-repo-name">{data?.repoName}</span>
                </>
            )}
        </>
    );
};

export default Version;
